import { useEffect, useState, type ComponentType } from "react";
import type { MapChef } from "./chef-map-utils";

type ChefMapProps = {
  chefs: MapChef[];
  height?: string;
  center?: [number, number];
  zoom?: number;
  userPosition?: [number, number] | null;
  showAttribution?: boolean;
};

export function ChefMapLazy(props: ChefMapProps) {
  const [Comp, setComp] = useState<ComponentType<ChefMapProps> | null>(null);

  useEffect(() => {
    let alive = true;
    import("./chef-map").then((m) => {
      if (alive) setComp(() => m.ChefMap);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!Comp) {
    return (
      <div
        style={{ height: props.height ?? "100%" }}
        className="grid w-full place-items-center bg-secondary/40 text-sm text-muted-foreground"
      >
        Caricamento mappa…
      </div>
    );
  }
  return <Comp {...props} />;
}